import React from 'react';
import { render } from 'react-dom';
import BatRackAdmin from './BatRackAdmin';

render(<BatRackAdmin />, document.getElementById('batrack-admin'));
